import { Box } from "@chakra-ui/react";

const calculatePercentage = (part: number, total: number) =>
  (part / total) * 100;

const QuantityProgressBar = ({
  quantityTotal,
  shipped,
  onOrder,
  remaining,
}: {
  quantityTotal: number;
  shipped: number;
  onOrder: number;
  remaining: number;
}) => {
  const shippedPercent = calculatePercentage(shipped, quantityTotal);
  const onOrderPercent = calculatePercentage(onOrder, quantityTotal);
  const remainingPercent = calculatePercentage(remaining, quantityTotal);

  const navy700 = `navy.700 ${shippedPercent}%`;
  const navy600 = `navy.600 ${shippedPercent + 0.01}%, navy.600 ${
    shippedPercent + onOrderPercent
  }%`;
  const gray100 = `gray.100 ${
    shippedPercent + onOrderPercent + 0.01
  }%, gray.100 ${shippedPercent + onOrderPercent + remainingPercent}%`;

  return (
    <Box
      h="24px"
      w="100%"
      borderRadius="full"
      bgGradient={`linear(to-r, ${navy700}, ${navy600}, ${gray100})`}
    />
  );
};

export default QuantityProgressBar;
